"use client"

import { useUser } from "@auth0/nextjs-auth0"
import { useEffect, useState } from "react"
import { DatabaseContext } from "./context"
import { TextAnalyticsPlusDexie } from "../db"

interface Props {
    children: React.ReactNode
}

export const DatabaseProvider: React.FC<Props> = ({ children }) => {
    const [database, setDatabase] = useState<TextAnalyticsPlusDexie>()
    const { user, isLoading } = useUser()

    useEffect(
        () => {
            if (!isLoading && user?.sub && database == null) {
                console.log("Opening database for user", user.sub)
                const db = new TextAnalyticsPlusDexie(user.sub)
                console.log("Opening database")
                db.open()
                    .then(() => setDatabase(db))
                    .catch(console.error)
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isLoading, user?.sub]
    )

    return <DatabaseContext.Provider value={{ database }}>{children}</DatabaseContext.Provider>
}
